import React, { useState, useEffect, useContext, useRef } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2'

import { AppContext } from "../../../services/AppContext";
import AuthContext from '../../../context/auth-context';

import { MdEdit, MdErrorOutline, MdSave, MdCheck } from "react-icons/md";

import useInput from '../../../hooks/useInput';
import useFileInput from '../../../hooks/useFileInput';
import useGetPaises from '../../../hooks/useGetPaises'
import useGetExperienciaLaboral from '../../../hooks/useGetExperienciaLaboral';
import useGetAmbito from '../../../hooks/useGetAmbito';


import Card from '../../UI/Card';
import useGetIndustria from '../../../hooks/useGetIndustria';
import useGetPropiedad from '../../../hooks/useGetPropiedad';
import useGetRelLaboral from '../../../hooks/useGetRelLaboral';
import useGetCanEmpleados from '../../../hooks/useGetCanEmpleados';
import useGetPuestoReporta from '../../../hooks/useGetPuestoReporta';
import useGetDepartamento from '../../../hooks/useGetDepartamento';
import useGetMes from '../../../hooks/useGetMes';

import useGetAnio from '../../../hooks/useGetAnio';
import useGetRangoSalarial from '../../../hooks/useGetRangoSalarial';
import useGetMonedaSalarioPanama from '../../../hooks/useGetMonedaSalarioPanama';
import useGetMonedaSalario from '../../../hooks/useGetMonedaSalario';

const ExperienciaLaboral = (props) => {
    const { setAppValues } = useContext(AppContext);
    const authContext = useContext(AuthContext);

    const[block, setBlock] = useState(false);
    const [error, setError] = useState(false);

    const paises = useGetPaises();
    const laboralData = useGetExperienciaLaboral(authContext.token);
    const ambitosArray = useGetAmbito();
    const industriaArray  = useGetIndustria();
    const propiedadArray  = useGetPropiedad();
    const relLaboralArray = useGetRelLaboral();
    const empleadosArray =useGetCanEmpleados();
    const puestoReportaArray = useGetPuestoReporta();
    const departamentoArray = useGetDepartamento();
    const mesArray = useGetMes();
    const anioArray = useGetAnio();
    const rangoSalarialArray = useGetRangoSalarial();
    const monedaArray = useGetMonedaSalario();
    

    useEffect(() => {

        if(laboralData.LOADING){
            Swal.fire({
                title: `Loading...
                    <div class="spinner-border text-primary mt-4" role="status" />
                `,
                showConfirmButton: false,
                allowOutsideClick: false,
                allowEscapeKey: false
            });
            return;
        }
        Swal.close();

        if(laboralData.STATUS && laboralData.STATUS === "SUCCESS"){
            setError(false);

        } else if(laboralData.STATUS && laboralData.STATUS === "ERROR"){
            setError(true);

            Swal.fire({
                icon: 'error',
                title: "¡Error!",
                text: laboralData.ERROR.MESSAGE,
                showConfirmButton: false,
                showDenyButton: true,
                denyButtonText: "Aceptar",
                backdrop: true,
                allowOutsideClick: false
            });

        } else {
            setError(true);
            
            Swal.fire({
                icon: 'error',
                title: "¡Error!",
                text: 'Ocurrió un problema, intentelo más tarde',
                showConfirmButton: false,
            });
        }

    }, [laboralData]);

    // ------------------------------------------------------------------------
    // ------------------------------------------------------------------------

    // INPUT EMPRESA
    const empresaValidacion = value => value.trim() !== "";
    const {
        value: empresa,
        isValid: empresaIsValid,
        isTouched: empresaIsTouched,
        userChange: empresaUserChange,
        divInput: divEmpresa,
        valueChangeHandler: empresaChangeHanlder,
        inputBlurHandler: empresaBlurHandler,
        resetInput: resetInputEmpresa,
        scrollToDiv: scrollToDivEmpresa,
        setInputValue: setEmpresaValue
    } = useInput(empresaValidacion);

    useEffect(() => {
        if(!!laboralData.empresa && !empresaUserChange){
            setEmpresaValue(laboralData.empresa);
        }
    }, [laboralData.empresa, empresaUserChange, setEmpresaValue]);

    // INPUT DIRECCION
    const direccionValidacion = value => value.trim() !== "";
    const {
        value: direccion,
        isValid: direccionIsValid,
        isTouched: direccionIsTouched,
        userChange: direccionUserChange,
        divInput: divDireccion,
        valueChangeHandler: direccionChangeHanlder,
        inputBlurHandler: direccionBlurHandler,
        resetInput: resetInputDireccion,
        scrollToDiv: scrollToDivDireccion,
        setInputValue: setDireccionValue
    } = useInput(direccionValidacion);

    useEffect(() => {
        if(!!laboralData.direccion && !direccionUserChange){
            setDireccionValue(laboralData.direccion);
        }
    }, [laboralData.direccion, direccionUserChange, setDireccionValue]);

    // INPUT PAIS
    const paisValidacion = value => value.trim() !== "";
    const {
        value: pais,
        isValid: paisIsValid,
        isTouched: paisIsTouched,
        userChange: paisUserChange,
        divInput: divPais,
        valueChangeHandler: paisChangeHanlder,
        inputBlurHandler: paisBlurHandler,
        resetInput: resetInputPais,
        scrollToDiv: scrollToDivPais,
        setInputValue: setPaisValue
    } = useInput(paisValidacion);

    useEffect(() => {
        if(!!laboralData.pais && !paisUserChange){
            setPaisValue(laboralData.pais);
        }
    }, [laboralData.pais, paisUserChange, setPaisValue]);

    // INPUT EXPERIENCIA
    const experienciaValidacion = value =>  value.trim() !== "" && 
                                            Number.isInteger(+value) && 
                                            parseInt(+value)>=0 && 
                                            parseInt(+value)<=99;
    const {
        value: experiencia,
        isValid: experienciaIsValid,
        isTouched: experienciaIsTouched,
        userChange: experienciaUserChange,
        divInput: divExperiencia,
        valueChangeHandler: experienciaChangeHanlder,
        inputBlurHandler: experienciaBlurHandler,
        resetInput: resetInputExperiencia,
        scrollToDiv: scrollToDivExperiencia,
        setInputValue: setExperienciaValue
    } = useInput(experienciaValidacion);

    useEffect(() => {
        if(!!laboralData.experiencia && !experienciaUserChange){
            setExperienciaValue(laboralData.experiencia);
        }
    }, [laboralData.experiencia, experienciaUserChange, setExperienciaValue]);

    // INPUT CARGO
    const cargoValidacion = value => value.trim() !== "";
    const {
        value: cargo,
        isValid: cargoIsValid,
        isTouched: cargoIsTouched,
        userChange: cargoUserChange,
        divInput: divCargo,
        valueChangeHandler: cargoChangeHanlder,
        inputBlurHandler: cargoBlurHandler,
        resetInput: resetInputCargo,
        scrollToDiv: scrollToDivCargo,
        setInputValue: setCargoValue
    } = useInput(cargoValidacion);

    useEffect(() => {
        if(!!laboralData.cargo && !cargoUserChange){
            setCargoValue(laboralData.cargo);
        }
    }, [laboralData.cargo, cargoUserChange, setCargoValue]);

    // INPUT REFERENCIA LABORAL
    const referenciaValidacion = value => value.trim() !== "";
    const {
        value: referencia,
        isValid: referenciaIsValid,
        isTouched: referenciaIsTouched,
        userChange: referenciaUserChange,
        divInput: divReferencia,
        valueChangeHandler: referenciaChangeHanlder,
        inputBlurHandler: referenciaBlurHandler,
        resetInput: resetInputReferencia,
        scrollToDiv: scrollToDivReferencia,
        setInputValue: setReferenciaValue
    } = useInput(referenciaValidacion);

    useEffect(() => {
        if(!!laboralData.referencia && !referenciaUserChange){
            setReferenciaValue(laboralData.referencia);
        }
    }, [laboralData.referencia, referenciaUserChange, setReferenciaValue]);

    // INPUT TELEFONO LABORAL DE CONTACTO
    const telefonoContactoValidacion = value => value.trim() !== "";
    const {
        value: telefonoContacto,
        isValid: telefonoContactoIsValid,
        isTouched: telefonoContactoIsTouched,
        userChange: telefonoContactoUserChange,
        divInput: divTelefonoContacto,
        valueChangeHandler: telefonoContactoChangeHanlder,
        inputBlurHandler: telefonoContactoBlurHandler,
        resetInput: resetInputTelefonoContacto,
        scrollToDiv: scrollToDivTelefonoContacto,
        setInputValue: setTelContactoValue
    } = useInput(telefonoContactoValidacion);

    useEffect(() => {
        if(!!laboralData.telefonoContacto && !telefonoContactoUserChange){
            setTelContactoValue(laboralData.telefonoContacto);
        }
    }, [laboralData.telefonoContacto, telefonoContactoUserChange, setTelContactoValue]);

    // INPUT CORREO LABORAL DE CONTACTO
    const correoContactoValidacion = value => {
        const emailRE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRE.test(value);
    };
    const {
        value: correoContacto,
        isValid: correoContactoIsValid,
        isTouched: correoContactoIsTouched,
        userChange: correoContactoUserChange,
        divInput: divCorreoContacto,
        valueChangeHandler: correoContactoChangeHanlder,
        inputBlurHandler: correoContactoBlurHandler,
        resetInput: resetInputCorreoContacto,
        scrollToDiv: scrollToDivCorreoContacto,
        setInputValue: setCorreoValue
    } = useInput(correoContactoValidacion);

    useEffect(() => {
        if(!!laboralData.correoContacto && !correoContactoUserChange){
            setCorreoValue(laboralData.correoContacto);
        }
    }, [laboralData.correoContacto, correoContactoUserChange, setCorreoValue]);

    // INPUT SECTOR
    const sectorValidacion = value => value.trim() !== "";
    const {
        value: sector,
        isValid: sectorIsValid,
        isTouched: sectorIsTouched,
        userChange: sectorUserChange,
        divInput: divSector,
        valueChangeHandler: sectorChangeHanlder,
        inputBlurHandler: sectorBlurHandler,
        resetInput: resetInputSector,
        scrollToDiv: scrollToDivSector,
        setInputValue: setSectorValue
    } = useInput(sectorValidacion);

    useEffect(() => {
        if(!!laboralData.sector && !sectorUserChange){
            setSectorValue(laboralData.sector);
        }
    }, [laboralData.sector, sectorUserChange, setSectorValue]);

    // INPUT LOGROS PROFESIONALES (ARCHIVO)
    const [nombreFile, setNombreFile] = useState("");
    const {
        value: logrosFile,
        fileName: logrosFileName,
        isValid: logrosFileIsValid,
        divInput: divLogros,
        valueChangeHandler: logrosFileChangeHanlder,
        inputBlurHandler: logrosFileBlurHandler
    } = useFileInput(nombreFile, "application/pdf");

    useEffect(() => {
        setNombreFile(!!laboralData.logrosFile ? laboralData.logrosFile : nombreFile);
    }, [laboralData.logrosFile, nombreFile, setNombreFile]);

    // INPUT LOGROS PROFESIONALES (TEXTO)
    const logrosTextoValidacion = value => value.trim() !== "";
    const {
        value: logrosTexto,
        userChange: logroTextoUserChange,
        valueChangeHandler: logrosTextoChangeHanlder,
        inputBlurHandler: logrosTextoBlurHandler,
        setInputValue: setLogroTextValue
    } = useInput(logrosTextoValidacion);

    useEffect(() => {
        if(!!laboralData.logrosTexto && !logroTextoUserChange){
            setLogroTextValue(laboralData.logrosTexto);
        }
    }, [laboralData.logrosTexto, logroTextoUserChange, setLogroTextValue]);


    //SELECT AMBITO DE TRABAJO
    const ambitoValidacion = value => value.trim() !== "";
    const {
        value: ambito,
        isValid: ambitoIsValid,
        isTouched: ambitoIsTouched,
        userChange: ambitoUserChange,
        divInput: divAmbito,
        valueChangeHandler: ambitoChangeHanlder,
        inputBlurHandler: ambitoBlurHandler,
        resetInput: resetInputAmbito,
        scrollToDiv: scrollToDivAmbito,
        setInputValue: setAmbitoValue
    } = useInput(ambitoValidacion);

    useEffect(() => {
        if(!!laboralData.ambito && !ambitoUserChange){
            setAmbitoValue(laboralData.ambito);
        }
    }, [laboralData.ambito, ambitoUserChange, setAmbitoValue]);



    
    //SELECT Industria
    const industriaValidacion = value => value.trim() !== "";
    const {
        value: industria,
        isValid: industriaIsValid,
        isTouched: industriaIsTouched,
        userChange: industriaUserChange,
        divInput: divIndustria,
        valueChangeHandler: industriaChangeHanlder,
        inputBlurHandler: industriaBlurHandler,
        resetInput: resetInputIndustria,
        scrollToDiv: scrollToDivIndustria,
        setInputValue: setIndustriaValue
    } = useInput(industriaValidacion);

    useEffect(() => {
        if(!!laboralData.industria && !industriaUserChange){
            setIndustriaValue(laboralData.industria);
        }
    }, [laboralData.industria, industriaUserChange, setIndustriaValue]);


      //SELECT Propiedad empresa
      const propiedadValidacion = value => value.trim() !== "";
      const {
          value: propiedad,
          isValid: propiedadIsValid,
          isTouched: propiedadIsTouched,
          userChange: propiedadUserChange,
          divInput: divPropiedad,
          valueChangeHandler: propiedadChangeHanlder,
          inputBlurHandler: propiedadBlurHandler,
          resetInput: resetInputPropiedad,
          scrollToDiv: scrollToDivPropiedad,
          setInputValue: setPropiedadValue
      } = useInput(propiedadValidacion);
  
      useEffect(() => {
          if(!!laboralData.propiedad && !propiedadUserChange){
              setPropiedadValue(laboralData.propiedad);
          }
      }, [laboralData.propiedad, propiedadUserChange, setPropiedadValue]);


      //INPUT administración laboral


     // const  comunValidacion = value => value === "1" || value === "2" ;
     //Es correcto de esta forma, que se guarda en este campo en academico

//     const adminValidacion = value => value === "1" || value === "2";
      const adminValidacion = value => value.trim() !=="";
      const {
          value: admin,
          isValid: adminIsValid,
          isTouched: adminIsTouched,
          userChange: adminUserChange,
          divInput: divAdmin,
          resetInput: resetInputadmin,
          valueChangeHandler: adminChangeHanlder,
          inputBlurHandler: adminBlurHandler,
          scrollToDiv: scrollToDivAdmin,
          setInputValue: setAdminValue
      } = useInput(adminValidacion);
  
      
      useEffect(() => {
          if(!!laboralData.adminFam && !adminUserChange){
              setAdminValue(laboralData.adminFam);
          }
      }, [laboralData.adminFam, adminUserChange, setAdminValue]);


      
      //SELECT Relación Laboral
      const relLabValidacion = value => value.trim() !== "";
      const {
          value: relLab,
          isValid: relLabIsValid,
          isTouched: relLabIsTouched,
          userChange: relLabUserChange,
          divInput: divrelLab,
          valueChangeHandler: relLabChangeHanlder,
          inputBlurHandler: relLabBlurHandler,
          resetInput: resetInputRelLab,
          scrollToDiv: scrollToDivRelLab,
          setInputValue: setRelLabValue
      } = useInput(relLabValidacion);
  
      useEffect(() => {
          if(!!laboralData.relLab && !relLabUserChange){
              setRelLabValue(laboralData.relLab);
          }
      }, [laboralData.relLab, relLabUserChange, setRelLabValue]);


      //SELECT Cantidad de empleados
      const empleadosValidacion = value => value.trim() !== "";
      const {
          value: empleados,
          isValid: empleadosIsValid,
          isTouched: empleadosIsTouched,
          userChange: empleadosUserChange,
          divInput: divempleados,
          valueChangeHandler: empleadosChangeHanlder,
          inputBlurHandler: empleadosBlurHandler,
          resetInput: resetInputEmpleados,
          scrollToDiv: scrollToDivEmpleados,
          setInputValue: setEmpleadosValue
      } = useInput(empleadosValidacion);
  
      useEffect(() => {
          if(!!laboralData.empleados && !empleadosUserChange){
              setEmpleadosValue(laboralData.empleados);
          }
      }, [laboralData.empleados, empleadosUserChange, setEmpleadosValue]);


       //SELECT Puesto Reporta 
       const puestoReportaValidacion = value => value.trim() !== "";
       const {
           value: puestoReporta,
           isValid: puestoReportaIsValid,
           isTouched: puestoReportaIsTouched,
           userChange: puestoReportaUserChange,
           divInput: divpuestoReporta,
           valueChangeHandler: puestoReportaChangeHanlder,
           inputBlurHandler: puestoReportaBlurHandler,
           resetInput: resetInputpuestoReporta,
           scrollToDiv: scrollToDivpuestoReporta,
           setInputValue: setpuestoReportaValue
       } = useInput(puestoReportaValidacion);
   
       useEffect(() => {
           if(!!laboralData.puestoreporta && !puestoReportaUserChange){
               setpuestoReportaValue(laboralData.puestoreporta);
           }
       }, [laboralData.puestoreporta, puestoReportaUserChange, setpuestoReportaValue]);

       //DEPARTAMENTO
       const departamentoValidacion = value => value.trim() !== "";
       const {
           value: departamento,
           isValid: departamentoIsValid,
           isTouched: departamentoIsTouched,
           userChange: departamentoUserChange,
           divInput: divDepartamento,
           valueChangeHandler: departamentoChangeHanlder,
           inputBlurHandler: deparmentoBlurHandler,
           resetInput: resetInputDepartamento,
           scrollToDiv: scrollToDivDepartamento,
           setInputValue: setDepartamentoValue
       } = useInput(departamentoValidacion);
   
       useEffect(() => {
           if(!!laboralData.departamento && !departamentoUserChange){
               setDepartamentoValue(laboralData.departamento);
           }
       }, [laboralData.departamento, departamentoUserChange, setDepartamentoValue]);


       // INPUT EMPLEADOS QUE LE REPORTAN
    const empleadosreportanValidacion = value =>  value.trim() !== "" && 
    Number.isInteger(+value) && 
    parseInt(+value)>=0 && 
    parseInt(+value)<=10000;
                const {
                value: empleadosreportan,
                isValid: empleadosreportanIsValid,
                isTouched: empleadosreportanIsTouched,
                userChange: empleadosreportanUserChange,
                divInput: divEmpleadosreportan,
                valueChangeHandler: empleadosreportanChangeHanlder,
                inputBlurHandler: empleadosreportanBlurHandler,
                resetInput: resetInputEmpleadosreportan,
                scrollToDiv: scrollToDivEmpleadosreportan,
                setInputValue: setEmpleadosreportanValue
                } = useInput(empleadosreportanValidacion);

                useEffect(() => {
                if(!!laboralData.empleadosreportan && !empleadosreportanUserChange){
                setEmpleadosreportanValue(laboralData.empleadosreportan);
                }
                }, [laboralData.empleadosreportan, empleadosreportanUserChange, setEmpleadosreportanValue]);

    //FECHA QUE INICIO A TRABAJAR: MES

     const mestrabajarValidacion = value => value.trim() !== "";
     const {
         value: mestrabajar,
         isValid: mestrabajarIsValid,
         isTouched: mestrabajarIsTouched,
         userChange: mestrabajarUserChange,
         divInput: divMestrabajar,
         valueChangeHandler: mestrabajarChangeHanlder,
         inputBlurHandler: mestrabajarBlurHandler,
         resetInput: resetInputmestrabajar,
         scrollToDiv: scrollToDivmestrabajar,
         setInputValue: setMestrabajarValue
     } = useInput(mestrabajarValidacion);
 
     useEffect(() => {
         if(!!laboralData.mestrabajar && !mestrabajarUserChange){
             setMestrabajarValue(laboralData.mestrabajar);
         }
     }, [laboralData.mestrabajar, mestrabajarUserChange, setMestrabajarValue]);

    //FECHA QUE INICIO A TRABAJAR: ANIO

    const aniotrabajarValidacion = value => value.trim() !== "";
    const {
        value: aniotrabajar,
        isValid: aniotrabajarIsValid,
        isTouched: aniotrabajarIsTouched,
        userChange: aniotrabajarUserChange,
        divInput: divAniotrabajar,
        valueChangeHandler: aniotrabajarChangeHanlder,
        inputBlurHandler: aniotrabajarBlurHandler,
        resetInput: resetInputaniotrabajar,
        scrollToDiv: scrollToDivaniotrabajar,
        setInputValue: setAniotrabajarValue
    } = useInput(aniotrabajarValidacion);

    useEffect(() => {
        if(!!laboralData.aniotrabajar && !aniotrabajarUserChange){
            setAniotrabajarValue(laboralData.aniotrabajar);
        }
    }, [laboralData.aniotrabajar, aniotrabajarUserChange, setAniotrabajarValue]);


    //Moneda SALARIO

    const monedaValidacion = value => value.trim() !== "";
    const {
        value: moneda,
        isValid: monedaIsValid,
        isTouched: monedaIsTouched,
        userChange: monedaUserChange,
        divInput: divMoneda,
        valueChangeHandler: monedaChangeHanlder,
        inputBlurHandler: monedaBlurHandler,
        resetInput: resetInputmoneda,
        scrollToDiv: scrollToDivmoneda,
        setInputValue: setMonedaValue
    } = useInput(monedaValidacion);

    useEffect(() => {
        if(!!laboralData.monedasalario && !monedaUserChange){
            setMonedaValue(laboralData.monedasalario);
        }
    }, [laboralData.monedasalario, monedaUserChange, setMonedaValue]);

    //Rango SALARIAL

    const rangosalarialValidacion = value => value.trim() !== "";
    const {
        value: rangosalarial,
        isValid: rangosalarialIsValid,
        isTouched: rangosalarialIsTouched,
        userChange: rangosalarialUserChange,
        divInput: divRangosalarial,
        valueChangeHandler: rangosalarialChangeHanlder,
        inputBlurHandler: rangosalarialBlurHandler,
        resetInput: resetInputrangosalarial,
        scrollToDiv: scrollToDivrangosalarial,
        setInputValue: setRangoSalarialValue
    } = useInput(rangosalarialValidacion);

    useEffect(() => {
        if(!!laboralData.rangosalarial && !rangosalarialUserChange){
            setRangoSalarialValue(laboralData.rangosalarial);
        }
    }, [laboralData.rangosalarial, rangosalarialUserChange, setRangoSalarialValue]);



    // INPUT TRABAJA
    const divTrabaja = useRef();
    const [trabaja, setTrabaja] = useState('');
    const [trabajaIsTouched, setTrabajaIsTouched] = useState(false);
    const trabajaIsValid = trabaja === "Y" || trabaja === "N";

    const handleEditar = () => {
        setBlock(!block);
    }

    const trabajaChangeHanlder = (event) => {
        setTrabaja(event.target.value);

        if(event.target.value === "N"){
            resetInputEmpresa();
            resetInputDireccion();
            resetInputPais();
            resetInputExperiencia();
            resetInputCargo();
            resetInputReferencia();
            resetInputTelefonoContacto();
            resetInputCorreoContacto();
            resetInputSector();
            resetInputAmbito();
            resetInputPropiedad();
            resetInputIndustria();
            resetInputadmin();   
            resetInputRelLab();
            resetInputEmpleados();
            resetInputpuestoReporta();
            resetInputDepartamento();
            resetInputEmpleadosreportan();
            resetInputmestrabajar();
            resetInputaniotrabajar();
            resetInputmoneda();
            resetInputrangosalarial();
        }
    }

    const trabajaBlurHandler = () => {
        setTrabajaIsTouched(true);
    }

    const headerOffset = 56;
    const scrollToDivTrabaja = () => {
        let pos = divTrabaja.current.getBoundingClientRect().top;
        let offset = pos + window.pageYOffset - headerOffset - parseInt(window.innerHeight/10);

        window.scrollTo({
            top: offset,
            behavior: "smooth"
        });
    }

    useEffect(() => {
        setTrabaja ((!!laboralData && "trabaja" in laboralData && trabaja === "") ? laboralData.trabaja : trabaja)
        if(trabaja === "N"){
            resetInputEmpresa();
            resetInputDireccion();
            resetInputPais();
            resetInputExperiencia();
            resetInputCargo();
            resetInputReferencia();
            resetInputTelefonoContacto();
            resetInputCorreoContacto();
            resetInputSector(); 

            resetInputAmbito();
            resetInputPropiedad();
            resetInputIndustria();
            resetInputadmin();  
            resetInputRelLab();
            resetInputEmpleados();
            resetInputpuestoReporta();
            resetInputDepartamento();
            resetInputEmpleadosreportan();
            resetInputmestrabajar();
            resetInputaniotrabajar();
            resetInputmoneda();
            resetInputrangosalarial();      


        }
    }, [laboralData, trabaja, setTrabaja, 
        resetInputEmpresa,
        resetInputDireccion,
        resetInputPais,
        resetInputExperiencia,
        resetInputCargo,
        resetInputReferencia,
        resetInputTelefonoContacto,
        resetInputCorreoContacto,
        resetInputSector,
        resetInputAmbito,
        resetInputPropiedad,
        resetInputIndustria,
        resetInputadmin,
        resetInputRelLab,
        resetInputEmpleados,
        resetInputpuestoReporta,
        resetInputDepartamento,
        resetInputEmpleadosreportan,
        resetInputmestrabajar,
        resetInputaniotrabajar,
        resetInputmoneda,
        resetInputrangosalarial
    ]); 

    useEffect(() => {
        let flag = !!laboralData.trabaja && laboralData.trabaja !== ""
        if(flag){
            setBlock(true);
            setIsUpdate(true);
        }
    }, [laboralData]);

    // ------------------------------------------------------------------------
    // ------------------------------------------------------------------------

    let trabajaActualmente = trabajaIsValid && trabaja === "Y";
    let formIsValid = false;

    if( trabajaIsValid ){

        if( trabaja === "Y" ){

            if( empresaIsValid && 
                direccionIsValid && 
                paisIsValid && 
                experienciaIsValid &&
                cargoIsValid &&
                referenciaIsValid &&
                telefonoContactoIsValid &&
                correoContactoIsValid &&
                sectorIsValid &&
                propiedadIsValid &&
                industriaIsValid &&
                ambitoIsValid &&
                relLabIsValid &&
                adminIsValid &&
                empleadosIsValid &&
                puestoReportaIsValid &&
                departamentoIsValid &&
                empleadosreportanIsValid &&
                mestrabajarIsValid &&
                aniotrabajarIsValid &&
                monedaIsValid 
                ){
                formIsValid = true;
            }
               
        } else if( trabaja === "N" ){
            formIsValid = true;
        }
    }

    const [isUpdate, setIsUpdate] = useState(false);

    const formSubmitHanlder = async(event) => {
        event.preventDefault();

        // Validacion visual de inputs
        trabajaBlurHandler();
        
        if( trabaja === "Y" ){
            empresaBlurHandler();
            direccionBlurHandler(); 
            paisBlurHandler();
            experienciaBlurHandler();
            cargoBlurHandler();
            referenciaBlurHandler();
            telefonoContactoBlurHandler();
            correoContactoBlurHandler();
            sectorBlurHandler();

            industriaBlurHandler();
            propiedadBlurHandler();
            ambitoBlurHandler();
            relLabBlurHandler();
            adminBlurHandler();
            empleadosBlurHandler();
            puestoReportaBlurHandler();
            deparmentoBlurHandler();
            empleadosreportanBlurHandler();
            mestrabajarBlurHandler();
            aniotrabajarBlurHandler();
            monedaBlurHandler();
            rangosalarialBlurHandler();
        }

        if(!formIsValid){
            setAppValues(
                prev => {
                    let perfil = prev.experienciaLaboral ? prev.perfil-20 : prev.perfil;
                    return { ...prev, experienciaLaboral: false, perfil };
                }
            );

            if(!trabajaIsValid){
                scrollToDivTrabaja();
                return;
            }

            if( trabaja === "Y" ){
                if(!empresaIsValid){
                    scrollToDivEmpresa();
                    return;
                }
    
                if(!direccionIsValid){
                    scrollToDivDireccion();
                    return;
                }
    
                if(!paisIsValid){
                    scrollToDivPais();
                    return;
                }
    
                if(!experienciaIsValid){
                    scrollToDivExperiencia();
                    return;
                }
    
                if(!cargoIsValid){
                    scrollToDivCargo();
                    return;
                }
    
                if(!referenciaIsValid){
                    scrollToDivReferencia();
                    return;
                }
    
                if(!telefonoContactoIsValid){
                    scrollToDivTelefonoContacto();
                    return;
                }
    
                if(!correoContactoIsValid){
                    scrollToDivCorreoContacto();
                    return;
                }
    
                if(!sectorIsValid){
                    scrollToDivSector();
                    return;
                }

                ///
                if(!ambitoIsValid){
                    scrollToDivAmbito();
                    return;
                }

                if(!propiedadIsValid){
                    scrollToDivPropiedad();
                    return;
                }

                if(!industriaIsValid){
                    scrollToDivIndustria();
                    return;
                }

                if(!relLabIsValid){
                    scrollToDivRelLab();
                    return;
                }

                if(!adminIsValid){
                    scrollToDivAdmin();
                    return;
                }

                if(!empleadosIsValid){
                    scrollToDivEmpleados();
                    return;
                }

                if(!puestoReportaIsValid){
                    scrollToDivpuestoReporta();
                    return;
                }

                if(!departamentoIsValid){
                    scrollToDivDepartamento();
                    return;   
                }

                if(!empleadosreportanIsValid){
                    scrollToDivEmpleadosreportan();
                    return;
                }

                if(!mestrabajarIsValid){
                    scrollToDivmestrabajar();
                    return;
                }

                if(!aniotrabajarIsValid){
                    scrollToDivaniotrabajar();
                    return;
                }

                if(!monedaIsValid){
                    scrollToDivmoneda();
                    return;
                }

                if(!rangosalarialIsValid){
                    scrollToDivrangosalarial();
                    return;
                }
                
            }

            return;
        }

        

        const form_data = new FormData();
        form_data.append('idToken', authContext.token);
        form_data.append('trabaja', trabaja);
        form_data.append('empresa', empresa);
        form_data.append('direccion', direccion);
        form_data.append('pais', pais === "" ? 'NULL': pais);
        form_data.append('experiencia', experiencia  === "" ? 0 : experiencia);
        form_data.append('cargo', cargo);
        form_data.append('referencia', referencia);
        form_data.append('telefonoContacto', telefonoContacto);
        form_data.append('correoContacto', correoContacto);
        form_data.append('sector', sector);
        form_data.append('logrosFile', logrosFile[0] === undefined ? nombreFile : logrosFile[0]);
        form_data.append('logrosTexto', logrosTexto);
        

        form_data.append('ambito', ambito === "" ? 'NULL': ambito);
        form_data.append('industria', industria === "" ? 'NULL': industria);
        form_data.append('propiedad', propiedad === "" ? 'NULL': propiedad);
        form_data.append('adminFam', admin === "" ? 'NULL': admin);
        form_data.append('relLab', relLab === "" ? 'NULL': relLab);
        form_data.append('empleados', empleados === "" ? 'NULL': empleados);
        form_data.append('mestrabajar', mestrabajar === "" ? 'NULL': mestrabajar);
        form_data.append('aniotrabajar', aniotrabajar === "" ? 'NULL': aniotrabajar);
        form_data.append('puestoreporta', puestoReporta === "" ? 'NULL': puestoReporta);
        form_data.append('departamento', departamento === "" ? 'NULL': departamento);
        form_data.append('empleadosreportan', empleadosreportan === "" ? 'NULL': empleadosreportan);
        form_data.append('monedasalario', moneda === "" ? 'NULL': moneda);
        form_data.append('rangosalarial', rangosalarial === "" ? 'NULL': rangosalarial);


       // console.log(form_data);





        if(isUpdate)
        {
            form_data.append('updateExperienciaLaboral', 1);
        }else {
            form_data.append('saveExperienciaLaboral', 1);
        }

        axios.post(process.env.REACT_APP_API_URL, form_data)
            .then(res => {
                setAppValues(
                    prev => {
                        let perfil = prev.experienciaLaboral ? prev.perfil : prev.perfil+20;
                        return { ...prev, experienciaLaboral: true, perfil };
                    }
                );
                setBlock(true);
                setIsUpdate(true);
                props.onCompletado('experiencia-laboral');
            })
            .catch((error) => {
                console.log(error)
                Swal.fire({
                    icon: 'error',
                    title: 'Ocurrió un problema, intentelo más tarde',
                    showConfirmButton: false,
                    timer: 3500
                });
            });
    }


    return (
        <>
        {
            error && 
            <div className="row">
                <div className="col-lg-12 mb-5">
                    <Card>
                        <div className="card-body d-flex align-items-center justify-content-center" style={{ height: '565px' }}>
                            <div className="text-center" style={{ color: 'rgba(0,0,0,.3)', fontSize: '2.5rem' }} >
                                <span style={{ fontSize: "7rem" }}><MdErrorOutline/></span>
                                <br />
                                ¡Error!
                            </div>
                        </div>
                    </Card>
                </div>
            </div>
        }
        { 
            !error && 
            <div className="row">
                <div className="col-lg-12 mb-5">
                    <Card>
                        <div className="card-body">
                            <form className="row my-4" onSubmit={formSubmitHanlder}>

                                {/* POSEE TRABAJO */}
                                <div className="col-md-10 offset-md-1 mb-3" ref={divTrabaja}>
                                    <label className="form-label text-black-50" style={{userSelect: "none"}}>¿Trabaja actualmente?</label>
                                    <div className="form-check">
                                        <input 
                                            type="radio"
                                            className={`form-check-input shadow-sm ${trabajaIsTouched ? ((trabajaIsValid) ? 'is-valid' : 'is-invalid') : ''} `}
                                            name="experiencia"
                                            value="Y"
                                            checked={trabaja === "Y"}
                                            onChange={trabajaChangeHanlder}
                                            onBlur={trabajaBlurHandler} 
                                            disabled={block}
                                        />
                                        <label className="form-check-label text-dark" style={{userSelect: "none"}}>Sí</label>
                                    </div>
                                    <div className="form-check">
                                        <input 
                                            type="radio"
                                            className={`form-check-input shadow-sm ${trabajaIsTouched ? ((trabajaIsValid) ? 'is-valid' : 'is-invalid') : ''} `}
                                            name="experiencia"
                                            value="N"
                                            checked={trabaja === "N"}
                                            onChange={trabajaChangeHanlder}
                                            onBlur={trabajaBlurHandler} 
                                            disabled={block}
                                            />
                                        <label className="form-check-label text-dark" style={{userSelect: "none"}}>No</label>
                                        <div className="invalid-feedback" style={{userSelect: 'none'}}>
                                            Debe seleccionar una opción
                                        </div>
                                    </div>
                                </div>

                                {/* EMPRESA */}
                                <div className="col-md-10 offset-md-1 mb-3" ref={divEmpresa}>
                                    <label className="form-label text-black-50" style={{userSelect: "none"}}>Empresa</label>
                                    <input 
                                        type="text" 
                                        name="empresa"
                                        className={`form-control form-control-sm shadow-sm ${empresaIsTouched ? ((empresaIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                                        placeholder="Nombre de la empresa"
                                        value={empresa}
                                        onChange={empresaChangeHanlder}
                                        onBlur={empresaBlurHandler} 
                                        disabled={!trabajaActualmente || block} />
                                    <div className="invalid-feedback" style={{userSelect: 'none'}}>
                                        Campo obligatorio
                                    </div>
                                </div>


                                  {/* AMBITO DE OPERACIONES */}
                                  <div className="col-md-6 offset-md-1 mb-3" ref={divAmbito}>
                                    <label className="form-label text-black-50" style={{userSelect: "none"}} htmlFor='ambito' >Ámbito de operaciones</label>

                                  
                                    
                                    <select 
                                        className={`form-select form-select-sm shadow-sm ${ambitoIsTouched ? ((ambitoIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                                        name='ambito' 
                                        value={ambito} 
                                        onChange={ambitoChangeHanlder}
                                        onBlur={ambitoBlurHandler}
                                        autoComplete='off'
                                        disabled={!trabajaActualmente || block} >
                                        <option value="">Seleccionar ámbito</option>
                                        { ambitosArray.map(ambito => (
                                            <option key={ambito.AMBITO_OPERACIONES} value={ambito.AMBITO_OPERACIONES}>{ambito.DESCRIPCION}</option>
                                        ))}
                                    </select>
                                    <div className="invalid-feedback" style={{userSelect: 'none'}}>
                                        Campo obligatorio
                                    </div>
                                </div>


                                  {/* Industria */}
                                  <div className="col-md-6 offset-md-1 mb-3" ref={divIndustria}>
                                    <label className="form-label text-black-50" style={{userSelect: "none"}} htmlFor='industria' >Industria</label>

                                  
                                    
                                    <select 
                                        className={`form-select form-select-sm shadow-sm ${industriaIsTouched ? ((industriaIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                                        name='industria' 
                                        value={industria} 
                                        onChange={industriaChangeHanlder}
                                        onBlur={industriaBlurHandler}
                                        autoComplete='off'
                                        disabled={!trabajaActualmente || block} >
                                        <option value="">Seleccionar industria</option>
                                        { industriaArray.map(industria => (
                                            <option key={industria.INDUSTRIA} value={industria.INDUSTRIA}>{industria.DESCRIPCION}</option>
                                        ))}
                                    </select>
                                    <div className="invalid-feedback" style={{userSelect: 'none'}}>
                                        Campo obligatorio
                                    </div>
                                </div>

                                
                                  {/* Propiedad */}
                                  <div className="col-md-6 offset-md-1 mb-3" ref={divPropiedad}>
                                    <label className="form-label text-black-50" style={{userSelect: "none"}} htmlFor='propiedad' >Propiedad de la empresa</label>

                                  
                                    
                                    <select 
                                        className={`form-select form-select-sm shadow-sm ${propiedadIsTouched ? ((propiedadIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                                        name='propiedad' 
                                        value={propiedad} 
                                        onChange={propiedadChangeHanlder}
                                        onBlur={propiedadBlurHandler}
                                        autoComplete='off'
                                        disabled={!trabajaActualmente || block} >
                                        <option value="">Seleccionar propiedad</option>
                                        { propiedadArray.map(propiedad => (
                                            <option key={propiedad.PROPIEDAD_EMPRESA} value={propiedad.PROPIEDAD_EMPRESA}>{propiedad.DESCRIPCION}</option>
                                        ))}
                                    </select>
                                    <div className="invalid-feedback" style={{userSelect: 'none'}}>
                                        Campo obligatorio
                                    </div>
                                </div>

                                
                                <div className="col-md-10 offset-md-1 mb-3" ref={divAdmin}>
                                    <label className="form-label text-black-50" style={{userSelect: "none"}}>¿La administración es familiar?</label>
                                    <div className="form-check">
                                        <input 
                                             type="radio"
                                             className={`form-check-input shadow-sm ${adminIsTouched ? ((adminIsValid) ? 'is-valid' : 'is-invalid') : ''} `}
                                             name="admin"
                                             value="1"
                                             checked={admin === "1"}
                                             onChange={adminChangeHanlder}
                                             onBlur={adminBlurHandler} 
                                             disabled={!trabajaActualmente || block} 
                                        />
                                        <label className="form-check-label text-black" style={{userSelect: "none"}}>Si</label>
                                    </div>

                                    <div className="form-check">
                                        <input 
                                            type="radio"
                                            className={`form-check-input shadow-sm ${adminIsTouched ? ((adminIsValid) ? 'is-valid' : 'is-invalid') : ''} `}
                                            name="admin"
                                            value="2"
                                            checked={admin === "2"}
                                            onChange={adminChangeHanlder}
                                            onBlur={adminBlurHandler} 
                                            disabled={!trabajaActualmente || block}
                                        />
                                        <label className="form-check-label text-black" style={{userSelect: "none"}}>No</label>
                                        <div className="invalid-feedback" style={{userSelect: 'none'}}>
                                            Debe seleccionar una opción
                                        </div>
                                    </div>
                                </div>


                                 {/* Relación Laboral */}
                                 <div className="col-md-6 offset-md-1 mb-3" ref={divrelLab}>
                                    <label className="form-label text-black-50" style={{userSelect: "none"}} htmlFor='relLab' >Relación laboral</label>

                                    <select 
                                        className={`form-select form-select-sm shadow-sm ${relLabIsTouched ? ((relLabIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                                        name='relLab' 
                                        value={relLab} 
                                        onChange={relLabChangeHanlder}
                                        onBlur={relLabBlurHandler}
                                        autoComplete='off'
                                        disabled={!trabajaActualmente || block} >
                                        <option value="">Seleccionar</option>

                                        
                                        {relLaboralArray.map(propiedad => (
                                            <option key={propiedad.RELACION_LABORAL} value={propiedad.RELACION_LABORAL}>{propiedad.DESCRIPCION}</option>
                                        ))}
                                    </select>
                                    <div className="invalid-feedback" style={{userSelect: 'none'}}>
                                        Campo obligatorio
                                    </div>
                                </div>

                                {/* DIRECCION */}
                                <div className="col-md-10 offset-md-1 mb-3" ref={divDireccion}>
                                    <label className="form-label text-black-50" style={{userSelect: "none"}}>Dirección</label>
                                    <input 
                                        type="text" 
                                        name="direccion"
                                        className={`form-control form-control-sm shadow-sm ${direccionIsTouched ? ((direccionIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                                        value={direccion}
                                        onChange={direccionChangeHanlder}
                                        onBlur={direccionBlurHandler}
                                        placeholder="Dirección de la empresa" 
                                        disabled={!trabajaActualmente || block} />
                                    <div className="invalid-feedback" style={{userSelect: 'none'}}>
                                        Campo obligatorio
                                    </div>
                                </div>

                                {/* PAIS */}
                                <div className="col-md-6 offset-md-1 mb-3" ref={divPais}>
                                    <label className="form-label text-black-50" style={{userSelect: "none"}} htmlFor='pais' >País</label>
                                    <select 
                                        className={`form-select form-select-sm shadow-sm ${paisIsTouched ? ((paisIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                                        name='pais' 
                                        value={pais} 
                                        onChange={paisChangeHanlder}
                                        onBlur={paisBlurHandler}
                                        autoComplete='off'
                                        disabled={!trabajaActualmente || block} >
                                        <option value="">Seleccionar país</option>
                                        {paises.map(pais => (
                                            <option key={pais.PAIS} value={pais.PAIS}>{pais.NOMBRE}</option>
                                        ))}
                                    </select>
                                    <div className="invalid-feedback" style={{userSelect: 'none'}}>
                                        Campo obligatorio
                                    </div>
                                </div>

                                {/*CANTIDAD DE EMPLEADOS*/}
                                <div className="col-md-6 offset-md-1 mb-3" ref={divempleados}>
                                    <label className="form-label text-black-50" style={{userSelect: "none"}} htmlFor='empleados' >Cantidad de empleados</label>

                                    <select 
                                        className={`form-select form-select-sm shadow-sm ${empleadosIsTouched ? ((empleadosIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                                        name='empleados' 
                                        value={empleados} 
                                        onChange={empleadosChangeHanlder}
                                        onBlur={empleadosBlurHandler}
                                        autoComplete='off'
                                        disabled={!trabajaActualmente || block} >
                                        <option value="">Seleccionar</option>

                                        {empleadosArray.map(empleados => (
                                            <option key={empleados.CANTIDAD_EMPLEADOS} value={empleados.CANTIDAD_EMPLEADOS}>{empleados.DESCRIPCION}</option>
                                        ))}
                                    </select>
                                    <div className="invalid-feedback" style={{userSelect: 'none'}}>
                                        Campo obligatorio
                                    </div>
                                </div>


                                {/*FECHA EN QUE INICIO A TRABAJAR*/}



                                            <div className="col-md-6 offset-md-1 mb-2">
                                            <label className="form-label text-black-50" style={{userSelect: "none"}}>Fecha en que inició a trabajar</label>
                                            </div>
                                            
                                             
                                   {/* MES*/}
                            
                                <div className="col-md-5 offset-md-1 mb-3" ref={divMestrabajar}>
                                    <select 
                                        className={`form-select form-select-sm shadow-sm ${mestrabajarIsTouched ? ((mestrabajarIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                                        name='mes' 
                                        value={mestrabajar} 
                                        onChange={mestrabajarChangeHanlder}
                                        onBlur={mestrabajarBlurHandler}
                                        autoComplete='off'
                                        disabled={!trabajaActualmente || block} >
                                        <option value="">Seleccionar mes</option>

                                        {mesArray.map(mesI => (
                                            <option key={mesI.ID_MES} value={mesI.ID_MES}>{mesI.NOMBRE}</option>
                                        ))}
                                    </select>
                                    <div className="invalid-feedback" style={{userSelect: 'none'}}>
                                        Campo obligatorio
                                    </div>
                                </div> 


                                  {/* AÑOS*/}

                                  <div className="col-md-5 mb-3" ref={divAniotrabajar}>
                                    <select 
                                        className={`form-select form-select-sm shadow-sm ${aniotrabajarIsTouched ? ((aniotrabajarIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                                        name='anio' 
                                        value={aniotrabajar} 
                                        onChange={aniotrabajarChangeHanlder}
                                        onBlur={aniotrabajarBlurHandler}
                                        autoComplete='off'
                                        disabled={!trabajaActualmente || block} >
                                        <option value="">Seleccionar año</option>

                                        {anioArray.map(anioI => (
                                            <option key={anioI.ANIO} value={anioI.ANIO}>{anioI.ANIO}</option>
                                        ))}
                                    </select>
                                    <div className="invalid-feedback" style={{userSelect: 'none'}}>
                                        Campo obligatorio
                                    </div>
                                </div> 
                               




                                         {/*PUESTO AL QUE REPORTA*/}
                                         <div className="col-md-6 offset-md-1 mb-3" ref={divpuestoReporta}>
                                    <label className="form-label text-black-50" style={{userSelect: "none"}} htmlFor='puestoReporta' >Puesto al que reporta</label>

                                    <select 
                                        className={`form-select form-select-sm shadow-sm ${puestoReportaIsTouched ? ((puestoReportaIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                                        name='puestoReporta' 
                                        value={puestoReporta} 
                                        onChange={puestoReportaChangeHanlder}
                                        onBlur={puestoReportaBlurHandler}
                                        autoComplete='off'
                                        disabled={!trabajaActualmente || block} >
                                        <option value="">Seleccionar</option>

                                        {puestoReportaArray.map(puestoReportai => (
                                            <option key={puestoReportai.PUESTO} value={puestoReportai.PUESTO}>{puestoReportai.DESCRIPCION}</option>
                                        ))}
                                    </select>
                                    <div className="invalid-feedback" style={{userSelect: 'none'}}>
                                        Campo obligatorio
                                    </div>
                                </div>


                                {/*DEPARTAMENTO*/}

                                           <div className="col-md-6 offset-md-1 mb-3" ref={divDepartamento}>
                                    <label className="form-label text-black-50" style={{userSelect: "none"}} htmlFor='departamento' >Departamento</label>

                                    <select 
                                        className={`form-select form-select-sm shadow-sm ${departamentoIsTouched ? ((departamentoIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                                        name='departamento' 
                                        value={departamento} 
                                        onChange={departamentoChangeHanlder}
                                        onBlur={deparmentoBlurHandler}
                                        autoComplete='off'
                                        disabled={!trabajaActualmente || block} >
                                        <option value="">Seleccionar</option>

                                        {departamentoArray.map(departamentoi => (
                                            <option key={departamentoi.DEPARTAMENTO} value={departamentoi.DEPARTAMENTO}>{departamentoi.DESCRIPCION}</option>
                                        ))}
                                    </select>
                                    <div className="invalid-feedback" style={{userSelect: 'none'}}>
                                        Campo obligatorio
                                    </div>
                                </div>


                                {/* AÑOS DE EXPERIENCIA LABORAL */}
                                <div className="col-md-6 offset-md-1 mb-3" ref={divExperiencia}>
                                    <label className="form-label text-black-50" style={{userSelect: "none"}}>Años de experiencia laboral</label>
                                    <div className="col-md-8">
                                        <input 
                                            type="number" 
                                            name="experiencia" 
                                            min={0} 
                                            max={99}
                                            value={experiencia}
                                            onChange={experienciaChangeHanlder}
                                            onBlur={experienciaBlurHandler}
                                            className={`form-control form-control-sm shadow-sm ${experienciaIsTouched ? ((experienciaIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                                            placeholder="Ingrese años"
                                            disabled={!trabajaActualmente || block} />
                                        <div className="invalid-feedback" style={{userSelect: 'none'}}>
                                            Campo obligatorio
                                        </div>
                                    </div>
                                </div>



                                
                                {/* CARGO */}
                                <div className="col-md-10 offset-md-1 mb-3" ref={divCargo}>
                                    <label className="form-label text-black-50" style={{userSelect: "none"}}>Cargo</label>
                                    <input 
                                        type="text" 
                                        name="cargo"
                                        value={cargo}
                                        onChange={cargoChangeHanlder}
                                        onBlur={cargoBlurHandler}
                                        className={`form-control form-control-sm shadow-sm ${cargoIsTouched ? ((cargoIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                                        placeholder="Cargo que desempeña"
                                        disabled={!trabajaActualmente || block} />
                                    <div className="invalid-feedback" style={{userSelect: 'none'}}>
                                        Campo obligatorio
                                    </div>
                                </div>


                                {/* CANTIDAD DE EMPLEADOS QUE LE REPORTAN */}
                                       <div className="col-md-8 offset-md-1 mb-3" ref={divEmpleadosreportan}>
                                    <label className="form-label text-black-50" style={{userSelect: "none"}}>Cantidad de empleados que le reportan</label>
                                    <div className="col-md-6">
                                        <input 
                                            type="number" 
                                            name="empleadosReportan" 
                                            min={0} 
                                           // max={1000}
                                            value={empleadosreportan}
                                            onChange={empleadosreportanChangeHanlder}
                                            onBlur={empleadosreportanBlurHandler}
                                            className={`form-control form-control-sm shadow-sm ${empleadosreportanIsTouched ? ((empleadosreportanIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                                            placeholder="Ingrese cantidad"
                                            disabled={!trabajaActualmente || block} />
                                        <div className="invalid-feedback" style={{userSelect: 'none'}}>
                                            Campo obligatorio
                                        </div>
                                    </div>
                                </div>


                                {/* Rango Salarial*/}

                                <div className="col-md-6 offset-md-1 mb-2">
                                            <label className="form-label text-black-50" style={{userSelect: "none"}}>Rango salarial actual</label>
                                            </div>
                                            
                                             
                                   {/*moneda*/}
                            
                                <div className="col-md-5 offset-md-1 mb-3" ref={divMoneda}>
                                    <select 
                                        className={`form-select form-select-sm shadow-sm ${monedaIsTouched ? ((monedaIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                                        name='moneda' 
                                        value={moneda} 
                                        onChange={monedaChangeHanlder}
                                        onBlur={monedaBlurHandler}
                                        autoComplete='off'
                                        disabled={!trabajaActualmente || block} >
                                        <option value="">Moneda</option>

                                        {monedaArray.map(monedaI => (
                                            <option key={monedaI.MONEDA} value={monedaI.MONEDA}>{monedaI.DESCRIPCION}</option>
                                        ))}
                                    </select>
                                    <div className="invalid-feedback" style={{userSelect: 'none'}}>
                                        Campo obligatorio
                                    </div>
                                </div> 


                                  {/* Rango */}

                                  <div className="col-md-5 mb-3" ref={divRangosalarial}>
                                    <select 
                                        className={`form-select form-select-sm shadow-sm ${rangosalarialIsTouched ? ((rangosalarialIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                                        name='rangosalarial' 
                                        value={rangosalarial} 
                                        onChange={rangosalarialChangeHanlder}
                                        onBlur={rangosalarialBlurHandler}
                                        autoComplete='off'
                                        disabled={!trabajaActualmente || block} >
                                        <option value="">Rango salarial</option>

                                        {rangoSalarialArray.map(rangoI => (
                                            <option key={rangoI.RANGO_SALARIAL} value={rangoI.RANGO_SALARIAL}>{rangoI.DESCRIPCION}</option>
                                        ))}
                                    </select>
                                    <div className="invalid-feedback" style={{userSelect: 'none'}}>
                                        Campo obligatorio
                                    </div>
                                </div> 

                                {/**/}


                                <hr className="col-md-10 offset-md-1 my-4 text-black-50 shadow-sm" />

                                {/* REFERENCIA LABORAL */}
                                <div className="col-md-10 offset-md-1 mb-3" ref={divReferencia}>
                                    <label className="form-label text-black-50" style={{userSelect: "none"}}>Referencia laboral</label>
                                    <input 
                                        type="text" 
                                        name="referencia"
                                        value={referencia}
                                        onChange={referenciaChangeHanlder}
                                        onBlur={referenciaBlurHandler}
                                        className={`form-control form-control-sm shadow-sm ${referenciaIsTouched ? ((referenciaIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                                        placeholder="Nombre de referencia laboral"
                                        disabled={!trabajaActualmente || block} />
                                    <div className="invalid-feedback" style={{userSelect: 'none'}}>
                                        Campo obligatorio
                                    </div>
                                </div>

                                {/* TELEFONO LABORAL DE CONTACTO */}
                                <div className="col-md-8 offset-md-1 mb-3" ref={divTelefonoContacto}>
                                    <label className="form-label text-black-50" style={{userSelect: "none"}} htmlFor='telefonoPersonal'>Teléfono laboral de contacto</label>
                                   
                                    {/* <div className="col-md-20">
                                    */}

                                    <div className="input-group">
                                    <select 
                                                            className={`form-select form-select-sm shadow-sm`}
                                                            value={pais} 
                                                            autoComplete='off'
                                                            disabled={true}
                                                         
                                                        >
                                                            <option value="" defaultValue={'DEFAULT'} hidden={true}>Código de área</option>
                                                            {paises.map(pais => (
                                                                <option key={pais.PAIS} value={pais.PAIS}>+{pais.CODIGO_AREA}</option>
                                                            ))}
                                                        </select>
                                        <input 
                                            type="text" 
                                            className={`form-control form-control-sm shadow-sm ${telefonoContactoIsTouched ? ((telefonoContactoIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                                            name='telefonoLaboralContacto' 
                                            value={telefonoContacto}
                                            onChange={telefonoContactoChangeHanlder}
                                            onBlur={telefonoContactoBlurHandler}
                                            placeholder="Ingrese teléfono"
                                            autoComplete='off'
                                            disabled={!trabajaActualmente || block}
                                            style={{
                                                width: '25%'
                                              }} />
                                        <div className="invalid-feedback" style={{userSelect: 'none'}}>
                                            Campo obligatorio
                                        </div>
                                        </div>
                                    </div>
                                    {/* </div> */}
                                



                

                                {/* CORREO LABORAL DE CONTACTO */}
                                <div className="col-md-8 offset-md-1 mb-3" ref={divCorreoContacto}>
                                    <label className="form-label text-black-50" style={{userSelect: "none"}}>Correo laboral de contacto</label>
                                    <input 
                                        type="email" 
                                        className={`form-control form-control-sm shadow-sm ${correoContactoIsTouched ? ((correoContactoIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                                        name='correoLaboralContacto'
                                        value={correoContacto}
                                        onChange={correoContactoChangeHanlder}
                                        onBlur={correoContactoBlurHandler}
                                        placeholder="ejemplo@empresa.com"
                                        autoComplete='off'
                                        disabled={!trabajaActualmente || block} />
                                    <div className="invalid-feedback" style={{userSelect: 'none'}}>
                                        Debe ingresar un correo válido
                                    </div>
                                </div>

                                {/* SECTOR */}
                                <div className="col-md-10 offset-md-1 mb-3" ref={divSector}>
                                    <label className="form-label text-black-50" style={{userSelect: "none"}}>Sector</label>
                                    <div className="form-check">
                                        <input 
                                            type="radio" 
                                            className={`form-check-input shadow-sm ${sectorIsTouched ? ((sectorIsValid) ? 'is-valid' : 'is-invalid') : ''} `}
                                            name="sector"
                                            value={"Público"}
                                            checked={sector === "Público"}
                                            onChange={sectorChangeHanlder}
                                            onBlur={sectorBlurHandler}
                                            disabled={!trabajaActualmente || block} />
                                        <label className="form-check-label text-dark" style={{userSelect: "none"}}>Público</label>
                                    </div>
                                    <div className="form-check">
                                        <input 
                                            type="radio"
                                            className={`form-check-input shadow-sm ${sectorIsTouched ? ((sectorIsValid) ? 'is-valid' : 'is-invalid') : ''} `}
                                            name="sector"
                                            value={"Privado"}
                                            checked={sector === "Privado"}
                                            onChange={sectorChangeHanlder}
                                            onBlur={sectorBlurHandler}
                                            disabled={!trabajaActualmente || block} />
                                        <label className="form-check-label text-dark" style={{userSelect: "none"}}>Privado</label>
                                        <div className="invalid-feedback" style={{userSelect: 'none'}}>
                                            Debe seleccionar una opción
                                        </div>
                                    </div>
                                </div>

                                {/* LOGROS PROFESIONALES */}
                                <div className="col-md-10 offset-md-1 mb-3" ref={divLogros}>

                                    {/* FILE */}
                                    <label className="form-label text-black-50" style={{userSelect: "none"}}>Logros profesionales</label>
                                    <input
                                        type="file"
                                        className={`form-control form-control-sm shadow-sm`}
                                        name="logros"
                                        onChange={logrosFileChangeHanlder}
                                        onBlur={logrosFileBlurHandler}
                                        disabled={block}
                                    />
                                    {logrosFileIsValid && <div className="form-text fst-italic" style={{userSelect: "none"}}>
                                        <span className="text-success"><MdCheck /></span> {logrosFileName}
                                    </div>}

                                    {/* TEXTAREA */}
                                    <div className="form-floating mt-1">
                                        <textarea 
                                            className={`form-control form-control-sm shadow-sm`}
                                            placeholder="Leave a comment here" 
                                            name="logrosTexto" 
                                            style={{height: '100px'}}
                                            value={logrosTexto}
                                            onChange={logrosTextoChangeHanlder}
                                            onBlur={logrosTextoBlurHandler}
                                            readOnly={block}></textarea>
                                        <label htmlFor="logrosTexto" className="text-black-50">Escriba sus logros profesionales</label>
                                        <div className={`form-text fst-italic`} style={{userSelect: 'none'}}>
                                            Adjuntar documento o escribir logros profesionales en el recuadro (5 líneas)
                                        </div>
                                    </div>
                                </div>
                                
                                {/* EDITAR/GUARDAR */}
                                <div className="col-md-10 offset-md-1 mt-3" style={{ textAlign: 'right' }}>
                                    <div className="btn-group">
                                        <button 
                                            className={`btn ${block ? 'btn-dark':'btn-outline-dark disabled'}`}
                                            type="button"
                                            onClick={() => handleEditar()}
                                            disabled={!block} >
                                            <MdEdit /> Editar
                                        </button>
                                        <button 
                                            className={`btn ${block ? 'btn-outline-danger disabled':'btn-danger'}`}
                                            type="submit"
                                            disabled={block} >
                                            <MdSave /> Guardar
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </Card>
                </div>
            </div>
        }
        </>
    )
}

export default ExperienciaLaboral